import { render, staticRenderFns } from "./PostFactSavingsButton.vue?vue&type=template&id=61e959de&lang=pug&"
import script from "./PostFactSavingsButton.vue?vue&type=script&lang=ts&"
export * from "./PostFactSavingsButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports